module.exports = __webpack_public_path__ + "img/lemon.5e5338b2.jpg";